<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';

let globalId = 0;
export default defineComponent({
  name: 'OIconLink',
  svgType: 'fill',
  setup() {
    const classNames = ['o-svg-icon', 'o-icon-link', 'type-fill'];
    const isClient = ref(false);
    onMounted(() => {
      isClient.value = true;
    });
    return {
      isClient,
      classNames,
      globalId: globalId++,
    };
  },
});
</script>
<template>
  <svg viewBox="0 0 24 24" :class="classNames">
    <template v-if="isClient">
      <path d="M11.122 9.9a.7.7 0 0 0-.902-.083l-.088.073-.554.543-.142.147c-1.175 1.285-1.217 3.186-.113 4.412l.138.144 4.972 4.867.154.142c1.447 1.26 3.705 1.144 5.147-.268 1.456-1.425 1.564-3.66.274-5.08l-.144-.149-1.921-1.881-.085-.072a.7.7 0 0 0-.975.982l.075.086 1.929 1.889.115.123c.753.872.651 2.222-.249 3.103-.914.895-2.322.986-3.216.24l-.124-.112-4.977-4.873-.11-.119c-.576-.686-.527-1.715.103-2.444l.125-.133.541-.53.083-.093a.7.7 0 0 0-.058-.912zM9.303 3.945c-1.447-1.26-3.705-1.144-5.147.268-1.456 1.425-1.564 3.66-.274 5.08l.144.149 1.921 1.881.085.072a.7.7 0 0 0 .975-.982l-.075-.086-1.929-1.889-.115-.123c-.753-.872-.651-2.222.249-3.103.914-.895 2.322-.986 3.216-.24l.124.112 4.977 4.873.11.119c.576.686.527 1.715-.103 2.444l-.125.133-.541.53-.083.093a.701.701 0 0 0 .96.995l.088-.073.554-.543.142-.147c1.175-1.285 1.217-3.186.113-4.412l-.138-.144-4.972-4.867-.154-.142z"/>
    </template>
  </svg>
</template>